import { NavigateFunction } from "react-router-dom"
import { PATH_INFO } from "../../utils/helper"
import { clientFetch } from "../../../utils/clientFetch"
import { MEASUREMENT_REPORT_DOWNLOAD_ERROR_MESSAGE_KEY } from "../../utils/measurementReportDownloadErrorMessage"
import i18n from "../../../i18n"

type DownloadMeasurementReportParams = {
  sampleId: string
  sampleUrl?: string | null
  sampleImage?: string | null
  sampleImages?: string[]
  navigate: NavigateFunction
}

export async function downloadMeasurementReport({
  sampleId,
  sampleUrl,
  sampleImage,
  sampleImages,
  navigate
}: DownloadMeasurementReportParams): Promise<string | null> {
  try {
    const body: Record<string, unknown> = { sample_id: sampleId, url: sampleUrl, language: i18n.language }
    if (sampleImages && sampleImages.length > 0) {
      body.sampleImages = sampleImages
    } else {
      body.sampleImage = sampleImage
    }

    const res = await clientFetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/client/export/measurement-report`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      handleUnauthorized: true
    })

    if (res.status === 401) {
      return null
    }
    if (res.status === 403) {
      navigate(PATH_INFO.LOGIN.PATH)
      return null
    }

    if (!res.ok) {
      await res.text().catch(() => "")
      return i18n.t(MEASUREMENT_REPORT_DOWNLOAD_ERROR_MESSAGE_KEY)
    }

    const blob = await res.blob()
    const downloadUrl = window.URL.createObjectURL(blob)
    const anchor = document.createElement("a")
    document.body.appendChild(anchor)
    anchor.href = downloadUrl
    anchor.download = "measurement_report.pdf"
    anchor.click()
    anchor.remove()
    window.URL.revokeObjectURL(downloadUrl)
    return null
  } catch (error) {
    console.error("採寸表ダウンロードに失敗しました。", error)
    return i18n.t(MEASUREMENT_REPORT_DOWNLOAD_ERROR_MESSAGE_KEY)
  }
}
